import { render, staticRenderFns } from "./add_clock.vue?vue&type=template&id=320a1f50&scoped=true"
import script from "./add_clock.vue?vue&type=script&lang=js"
export * from "./add_clock.vue?vue&type=script&lang=js"
import style0 from "./add_clock.vue?vue&type=style&index=0&id=320a1f50&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a1f50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('320a1f50')) {
      api.createRecord('320a1f50', component.options)
    } else {
      api.reload('320a1f50', component.options)
    }
    module.hot.accept("./add_clock.vue?vue&type=template&id=320a1f50&scoped=true", function () {
      api.rerender('320a1f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/attendance_details/components/add_clock.vue"
export default component.exports